import classNames from 'classnames';
import { useContext } from 'react';
import { CollectionSettingsOpenDispatchContext } from '../../../context/CollectionSettingsContextProvider/openContext';
import { SETTINGS_PAGE } from '../constants';
import {
  CollectionSettingsDataContext,
  CollectionSettingsPageContext,
  CollectionSettingsPageDispatchContext,
} from '../contextProvider';
import styles from './Sidebar.module.css';
import SidebarItem from './SidebarItem';

function Sidebar() {
  const settingsPage = useContext(CollectionSettingsPageContext);
  const setSettingsPage = useContext(CollectionSettingsPageDispatchContext);
  const setsettingsOpen = useContext(CollectionSettingsOpenDispatchContext);
  const { tableConnected } = useContext(CollectionSettingsDataContext);

  return (
    <div data-testid="CollectionSettings_Sidebar_container" className={classNames(styles.sidebar)}>
      <div
        className={classNames(styles.container, 'pt-4', 'pb-6')}
        role="none"
        onClick={() => {
          setsettingsOpen(false);
        }}
      >
        <div className={classNames(styles.center, 'is-size-5')}>Settings</div>
      </div>

      <SidebarItem
        left={<div style={{ width: 0 }} />}
        center="Data Setup"
        selected={settingsPage === SETTINGS_PAGE.DATA_SETUP}
        containerClassname={styles.sidebarLeftMargin}
        onClick={() => setSettingsPage(SETTINGS_PAGE.DATA_SETUP)}
      />

      <SidebarItem
        left={<div style={{ width: 0 }} />}
        center="Table"
        selected={settingsPage === SETTINGS_PAGE.CONNECT_TABLE}
        containerClassname={styles.sidebarLeftMargin}
        onClick={() => setSettingsPage(SETTINGS_PAGE.CONNECT_TABLE)}
      />
      {tableConnected && (
        <>
          <SidebarItem
            left={<div style={{ width: 0 }} />}
            center="Fields"
            selected={settingsPage === SETTINGS_PAGE.FIELDS}
            containerClassname={styles.sidebarLeftMargin}
            onClick={() => setSettingsPage(SETTINGS_PAGE.FIELDS)}
          />
          <SidebarItem
            left={<div style={{ width: 0 }} />}
            center="Template"
            selected={settingsPage === SETTINGS_PAGE.TEMPLATE}
            containerClassname={styles.sidebarLeftMargin}
            onClick={() => setSettingsPage(SETTINGS_PAGE.TEMPLATE)}
          />
          <SidebarItem
            left={<div style={{ width: 0 }} />}
            center="Sort & Filter"
            selected={settingsPage === SETTINGS_PAGE.SORT_FILTER}
            containerClassname={styles.sidebarLeftMargin}
            onClick={() => setSettingsPage(SETTINGS_PAGE.SORT_FILTER)}
          />
          <SidebarItem
            left={<div style={{ width: 0 }} />}
            center="Search"
            selected={settingsPage === SETTINGS_PAGE.SEARCH}
            containerClassname={styles.sidebarLeftMargin}
            onClick={() => setSettingsPage(SETTINGS_PAGE.SEARCH)}
          />
        </>
      )}
    </div>
  );
}

export default Sidebar;
